import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton } from "bootstrap-vue";
import { useRouter } from "vue-router/composables";
import { useConfig } from "@/composables/config";
import BroadcastsList from "@/components/admin/Notifications/BroadcastsList.vue";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsManagement',
    setup(__props) {
        const router = useRouter();
        const { config, isConfigLoaded } = useConfig();
        function goToCreateNewNotification() {
            router.push("/admin/notifications/create_new_notification");
        }
        function goToCreateNewBroadcast() {
            router.push("/admin/notifications/create_new_broadcast");
        }
        return { __sfc: true, router, config, isConfigLoaded, goToCreateNewNotification, goToCreateNewBroadcast, FontAwesomeIcon, BAlert, BButton, BroadcastsList, Heading };
    }
});
